enum TEBadgeSignal {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
  Brand = 'brand',
  Neutral = 'neutral',
  Overlay = 'overlay',
}

export default TEBadgeSignal;
